import * as React from 'react';
import { ILoadPurchaseOrderDialogProps } from './LoadPurchaseOrderDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import LoadPurchaseOrderForm from './LoadPurchaseOrderDialog.form';
import { useLoadPurchaseOrder, useRetrievePurchaseOrdersSummary } from 'api/purchaseOrders/purchaseOrders';
import { usePOContextSelector } from '../PurchaseOrders.context';

const LoadPurchaseOrderDialog = (props: ILoadPurchaseOrderDialogProps): JSX.Element => {
  const { open, onClose, linesRef, values, initialValues, valuesSchema } = props;
  const params = new URLSearchParams(location.search);
  const PurchaseOrder = usePOContextSelector<'PurchaseOrder'>((state) => state.PurchaseOrder) || params.get('PurchaseOrder');
  const fetchPOSummary = useRetrievePurchaseOrdersSummary(PurchaseOrder);

  const { mutateAsync: loadPurchaseOrderMutateAsync, isLoading: isProcessing } = useLoadPurchaseOrder();
  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Ok',
        disabled: !(values?.LoadFromPurchaseOrder && (values?.LoadNotesAndComments || values?.LoadWarehouseAndDelivery || values?.LoadProducts)) || isProcessing,
        listener: async () => {
          const response = await loadPurchaseOrderMutateAsync({
            ...values,
            PurchaseOrder
          });

          if (response?.Status) {
            linesRef.current?.refreshDataGrid();
            fetchPOSummary?.refetch();
            onClose();
          }
        }
      },
      {
        title: 'Cancel',
        isDefault: true,
        listener: () => {
          onClose();
        }
      }
    ];
  };

  return (<FormViewModal
    open={open}
    loading={false}
    title='Load Purchase Order'
    formProps={{
      style: {
        height: '395px',
        minWidth: '450px'
      },
      formSchema: LoadPurchaseOrderForm,
      initialValues: initialValues || {},
      valuesSchema: valuesSchema,
    }}
    actions={confirmationActions()}
    dialogActionsButtons={true}
    dialogActionsShadow={false}

  />);
};

export default LoadPurchaseOrderDialog;
